module.exports = __webpack_public_path__ + "static/media/comingSoon.087ca396.jpg";